/**
 * This file should be loaded through theme (ie. manifest in sage)
 */
if (typeof YsAjaxLoader !== 'undefined') {
  jQuery(document).ready(YsAjaxLoader.init);
}
